<template>
  <div :class="['c-title-wrap',{'mar-top-40':hasMargin}]">
    <el-row>
      <el-col :span="12">
        <div class="c-title">{{title}}</div>
      </el-col>
    
      <el-col :span="12" v-if="showModel" class="el-end">
          <div class="model-title">大模型推荐 
            <el-button 
               @click="refresh" 
               type="text"
               :disabled="refreshBtn"
            >
               刷新
            </el-button>
            <el-tooltip class="item" effect="dark" content="刷新功能仅在模型迭代时产生效果，加载大约需要3分钟，再次刷新请间隔10分钟" placement="top">
               <el-button class="tipIcon" size="mini" type="text" icon="el-icon-warning-outline"></el-button>
            </el-tooltip>
            <el-button
               v-if="showEmpty" 
               type="text"
               disabled
               :loading="isLoading"
              class="emptyText"
            >
              {{loadingTip}}
            </el-button>

          </div>
          <el-button 
            :type="!applyStatus ? 'primary' : 'info'" 
            size="small" 
            class="q-apply"
            @click="onceApply"
          >
          {{applyStatus? '一键取消' : '一键应用'}}
        </el-button>

      </el-col>

    </el-row>



  </div>
</template>

<script>
export default {
  name: "cTitle",
  props: ['title','hasMargin', 'showModel', 'showEmpty', 'loadingTip', 'isLoading'],
  data: () => {
    return {
       applyStatus: false,
       refreshBtn: false,
       timer: '',
       value: 0
    }
  },
  methods: {
    onceApply() {
       this.applyStatus = !this.applyStatus;
       this.$emit('clickOnceApply',this.applyStatus);
    },
    get() {
        this.value ++;
        console.log(this.value);
        if (this.value >= 1) {
          clearInterval(this.timer);
          this.refreshBtn = false;
        }
  
      },
    refresh() {
      this.refreshBtn = true;
      this.timer = setInterval(() => {
        this.get();
      }, 600000);
      this.$emit('largeModelRefresh');
    }

  },
  beforeDestroy() {
    clearInterval(this.timer);
  }

}
</script>

<style lang="scss" scoped>
    .model-title {
      display: flex;
      align-items: center;
      line-height: 14px;
      height: 20px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #333840;
      button {
        font-size: 13px;
        line-height: 14px;
        margin-left: 5px;
      }
      .emptyText {
         margin-left: 5px;
         font-size: 13px;
         color: rgba(195, 195, 195, 1);
      }
      .tipIcon {
        margin-left: 0px;
      }
    }

    .el-end {
         display: flex;
         justify-content: space-between;
         padding-right: 50px;

         .q-apply {
            margin-top: -5px;
         }
    }
   
</style>
